import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { blogArticles } from "@/mocks/categories";

export default function BlogSection() {
  const { t } = useTranslation();

  const articles = blogArticles.slice(0, 10);

  return (
    <section id="blog" className="w-full bg-background-100/50 py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            Expert Guides
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            {t("blog.section.title")}
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            {t("blog.section.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group rounded-lg border border-background-200/70 bg-background-50 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={t(article.titleKey)}
                  title={t(article.titleKey)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs text-accent-600 font-medium mb-2 block">
                  Beginner Friendly · 8 Min Read
                </span>
                <h3 className="font-heading text-sm md:text-base text-foreground-900 group-hover:text-primary-500 transition-colors mb-2 line-clamp-2 leading-snug">
                  {t(article.titleKey)}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {t(article.descKey)}
                </p>
                <span className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer">
                  {t("blog.card.cta")}
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}